






















































































































































































































































import Vue from 'vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import linkify from 'vue-linkify'

import { escapeHtml } from '~/helpers/FormatHelper'

Vue.directive('linkified', linkify)

export default Vue.extend({
	props: {
		comment: {
			type: Object,
			required: true,
		},
		index: {
			type: Number,
			required: true,
		},
		now: {
			type: Object,
			required: true,
		},
		calculateDateDifference: {
			type: Function,
			required: true,
		},
		likeComment: {
			type: Function,
			required: true,
		},
		removeCommentLike: {
			type: Function,
			required: true,
		},
		deleteComment: {
			type: Function,
			required: true,
		},
		commentDeletionConfirmedFor: {
			type: String,
			default: null,
		},
		postId: {
			type: String,
			default: null,
		},
		articleId: {
			type: String,
			default: null,
		},
	},
	asyncData({ params }) {
		return {
			comment: params.comment,
			postId: params.postId ?? null,
			articleId: params.articleId ?? null,
		}
	},
	data() {
		return {
			newReplyText: '',
			replyingTo: <any> null,
			subComments: <any> [],
			moreRepliesAvailable: false,
			selectedCommentForLikes: <any> null,
			commentLikes: <Array<any>|null> null,
			replyPollingInterval: <any> null,
			reported: false,
			selectedCommentForReport: <any> null,
			reportTypes: [
				{
					name: 'Spam',
					value: 'spam',
				},
				{
					name: 'Unangemessener Inhalt',
					value: 'inappropriate_content',
				},
			],
			reportType: '',
			reportText: '',
		}
	},
	mounted() {
		this.$axios.get(`/api/network/comment/${this.comment.id}/replies`, {
			params: {
				type: this.articleId ? 'news' : 'post',
				limit: 3,
			},
		}).then((resp) => {
			this.subComments = resp.data.comments.reverse()
			this.moreRepliesAvailable = resp.data.more_comments_available
			this.startPollingInterval()
		})

		window.addEventListener('focus', this.startPollingInterval)
		window.addEventListener('blur', this.stopPollingInterval)
	},
	beforeDestroy() {
		this.stopPollingInterval()
		window.removeEventListener('focus', this.startPollingInterval)
		window.removeEventListener('blur', this.stopPollingInterval)
	},
	methods: {
		submitComment() {
			this.$axios.post(
				this.postId
					? `/api/network/post/${this.postId}/comment`
					: `/api/network/news/${this.articleId}/comment`,
				{
					text: this.newReplyText,
					replying_to: this.comment.id,
					quoting: this.replyingTo.id !== this.comment.id ? this.replyingTo.id : null,
				},
			).then((response) => {
				if (response.data.status === 'ok') {
					this.newReplyText = ''

					if (!this.subComments) {
						this.subComments = []
					}

					this.subComments.push(response.data.comment)
					// eslint-disable-next-line vue/no-mutating-props
					this.comment.reply_count += 1
					this.replyingTo = null
				} else {
					this.$nuxt.$emit('showToastMessage', {
						message: this.$t('error.unkown').toString(),
						duration: 3000,
					})
				}
			}).catch((error) => {
				console.log(error)
				this.$nuxt.$emit('showToastMessage', {
					message: this.$t('error.unkown').toString(),
					duration: 3000,
				})
			})
		},
		loadMoreReplies() {
			this.$axios.get(`/api/network/comment/${this.comment.id}/replies`, {
				params: {
					type: this.articleId ? 'news' : 'post',
					limit: 10,
					older_than: this.subComments[0].id,
				},
			}).then((resp) => {
				this.subComments.unshift(...resp.data.comments.reverse())
				this.moreRepliesAvailable = resp.data.more_comments_available
			})
		},
		pollReplies() {
			this.$axios.get(`/api/network/comment/${this.comment.id}/replies`, {
				params: {
					order: 'asc',
					type: this.articleId ? 'news' : 'post',
					newer_than: this.subComments && this.subComments.length
						? this.subComments[this.subComments.length - 1].id
						: null,
					limit: 10,
				},
			}).then((response) => {
				if (response.data.status === 'ok') {
					this.subComments.push(...response.data.comments)
				}
			})
		},
		reportComment() {
			this.$axios.put(`/api/network/comment/${this.selectedCommentForReport.id}/report`, {
				comment_type: this.articleId ? 'news' : 'post',
				type: this.reportType,
				reason: this.reportText,
			}).then((resp) => {
				if (resp.data.status === 'ok') {
					this.reported = true
					this.reportText = ''
				} else if (resp.data.status === 'already_reported') {
					this.$nuxt.$emit('showToastMessage', {
						message: 'Anscheinend haben Sie den Beitrag bereits gemeldet.',
						duration: 2500,
					})
				} else {
					this.$nuxt.$emit('showToastMessage', {
						// eslint-disable-next-line max-len
						message: 'Beim Melden des Beitrages ist ein Fehler aufgetreten. Möglicherweise haben Sie den Beitrag bereits gemeldet.',
						duration: 2500,
					})
				}
			}).catch((err) => {
				if (err.response.status === 429) {
					this.$nuxt.$emit('showToastMessage', {
						message: 'Too many reports sent. Please try again later.',
						duration: 2500,
					})
				} else {
					this.$nuxt.$emit('showToastMessage', {
						// eslint-disable-next-line max-len
						message: 'Beim Melden des Beitrages ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut, oder kontaktieren Sie ggf. den Support.',
						duration: 2500,
					})
				}
			})
		},
		showLikesOfComment(comment: any) {
			if (!this.$auth.loggedIn) {
				return
			}

			this.selectedCommentForLikes = comment

			this.$axios.get(`/api/network/comment/${this.selectedCommentForLikes.id}/likes`, {
				params: {
					limit: 10,
				},
			}).then((response) => {
				if (response.data.status === 'ok') {
					this.commentLikes = response.data.likes
				}
			})
		},
		loadMoreLikes() {
			if (!this.commentLikes) {
				return
			}

			this.$axios.get(`/api/network/post/${this.selectedCommentForLikes.id}/likes`, {
				params: {
					offset: this.commentLikes.length,
					limit: 10,
				},
			}).then((response) => {
				if (response.data.status === 'ok' && this.commentLikes) {
					this.commentLikes.push(...response.data.likes)
				}
			})
		},
		escapeHtml(text: string, comment: any) {
			let escapedHtml = escapeHtml(text)

			if (comment.mentions) {
				comment.mentions.forEach((mention: any) => {
					escapedHtml = escapedHtml.replace(
						mention.key,
						`<a href="/company/${mention.key.replace('@', '')}">@${mention.name}</a>`,
					)
				})
			}

			return escapedHtml
		},
		startPollingInterval() {
			this.replyPollingInterval = setInterval(
				this.pollReplies,
				20000 + Math.floor(Math.random() * Math.floor(20000)),
			)
		},
		stopPollingInterval() {
			clearInterval(this.replyPollingInterval)
		},
	},
})
